import React, { Fragment, Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Row, Col } from 'antd';
import { connect } from 'react-redux';
import queryString from 'query-string';
import {
  max,
  round,
  cloneDeep,
  keyBy,
  filter,
  get,
  orderBy,
  concat,
  remove,
  size,
  map,
  isEmpty
} from 'lodash';

import CountrySelect from './CountrySelect';
import ParcelForm from './ParcelForm';
import QuotationButton from './QuotationButton';
import QuotationResult from './QuotationResult';
import LoginDrawer from './LoginDrawer';
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyledPopup } from 'components/Styled';

import countriesData from 'data/countries';

import helpers from 'utils/helpers';

import Popup from 'components/common/Popup';

import {
  getQuotationRequest,
  getAutoSaveRequest,
  getCountriesRequest,
  getCategoriesRequest,
  getAreasRequest
} from 'ducks/shipments';

import { addCouponRequest } from 'ducks/users';

import ImagePlane from 'assets/images/plane.svg';

class Quotation extends Component {
  constructor(props) {
    super(props);
    const country = helpers.getCurrentCountry(true);

    this.state = {
      origin: country,
      destination: country !== 'HK' ? 'HK' : 'US',
      boxData: {},
      previewWeight: 0,
      selectedRate: null,
      drawerEmail: '',
      drawerPage: 'register',
      drawerVisible: false,
      rates: [],
      autosaveLoaded: false
    };

    this.resultDiv = React.createRef();
  }

  handleOriginChange = value => {
    if (value === this.state.origin) return;

    const newState = {
      origin: value
    };

    if (value && value !== 'HK') newState.destination = 'HK';
    if (value === 'HK' && this.state.destination === 'HK')
      newState.destination = this.state.origin;
    newState.originStatus = value ? '' : 'error';
    if (newState.destination) newState.destinationStatus = '';

    this.setState(newState);
    this.props.getQuotationRequest({ reset: true });
  };

  handleDestinationChange = value => {
    if (value === this.state.destination) return;

    const newState = {
      destination: value
    };

    if (value && value !== 'HK') newState.origin = 'HK';
    if (value === 'HK' && this.state.origin === 'HK')
      newState.origin = this.state.destination;
    newState.destinationStatus = value ? '' : 'error';
    if (newState.origin) newState.originStatus = '';

    this.setState(newState);
    this.props.getQuotationRequest({ reset: true });

    window.dataLayer.push({
      event: 'Select Destination',
      ecommerce: undefined
    });
  };

  handleBoxDataChange = boxData => {
    this.setState({
      boxData
    });

    this.props.getQuotationRequest({ reset: true });
  };

  handleServiceClick = index => {
    const { origin, destination, boxData } = this.state;
    const { rates } = this.state;

    const product = {
      id: `${origin}-${destination}`,
      name: `${origin}-${destination}`,
      price: rates[index]?.naturalAmount?.totalRate || rates[index]?.totalRate,
      brand: rates[index].service,
      category: helpers.getWeightCategory(boxData.totalWeight),
      position: index + 1
    };

    const booking = {
      bookService: rates[index].service,
      courier: rates[index].carrier,
      origin,
      destination,
      chargableWeight: boxData.totalWeight,
      value: rates[index]?.naturalAmount?.totalRate || rates[index]?.totalRate
    };

    window.dataLayer.push({
      event: 'Select Service',
      ecommerce: {
        currencyCode: 'HKD',
        click: {
          actionField: { list: 'Search Results' },
          products: [product]
        }
      }
    });

    window.dataLayer.push({
      event: 'Select Service',
      ecommerce: {
        currencyCode: 'HKD',
        detail: {
          actionField: { list: 'Search Results' },
          products: [product]
        }
      },
      booking
    });

    this.setState(
      {
        selectedRate: index
      },
      this.handleNext
    );
  };

  gotoNext = () => {
    const { origin, destination, selectedRate, boxData, rates } = this.state;
    const { carrier, service, totalRate, naturalAmount } = rates[selectedRate];

    return this.props.handleNext({
      origin,
      destination,
      carrier,
      service,
      boxData,
      totalRate,
      selectedService: rates[selectedRate],
      rates,
      firstMileProvider: rates[selectedRate].firstMileProvider,
      currency: totalRate?.currency || 'HKD',
      ...naturalAmount
    });
  };

  handleNext = () => {
    window.dataLayer.push({ event: 'Submit Quotation', ecommerce: undefined });

    if (this.props.user && this.props.basic) {
      return this.gotoNext();
    }

    this.setState({
      drawerPage: this.props.user ? 'basic' : 'login'
    });

    this.handleDrawerOpen();
  };

  handleDrawerClose = () => {
    this.setState({
      drawerVisible: false
    });
  };

  handleDrawerOpen = () => {
    this.setState({
      drawerVisible: true
    });
  };

  handlePageChange = (page, options = {}) => {
    const { email } = options;
    this.setState({
      drawerEmail: email,
      drawerPage: page
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.rates !== this.props.rates) {
      let rates = cloneDeep(this.props.rates);

      let featured = remove(rates, x =>
        get(x, `promotes.${this.props.t('key')}.featured`)
      );

      let speedpost = remove(rates, x => get(x, 'carrier') === 'speedpost');

      featured = orderBy(featured, 'totalRate', 'desc');
      rates = orderBy(rates, 'totalRate', 'asc');
      speedpost = orderBy(speedpost, 'totalRate', 'asc');

      // Filter out spaceship-light option, as v1 does not support it
      rates = rates.filter(rate => rate.service !== 'spaceship-light');

      this.setState({
        rates: concat(featured, rates, speedpost)
      });
    }

    if (!prevProps.showRates && this.props.showRates) {
      setTimeout(() => {
        const params = queryString.parse(this.props.location.search);
        const serviceDiv = document.getElementById(params?.service);
        const selectedDiv = serviceDiv || this.resultDiv.current;

        window.scrollTo(0, selectedDiv.offsetTop);
      }, 0);

      this.setState({
        previewWeight: max([
          this.state.boxData.totalVolumeWeight,
          this.state.boxData.totalWeight
        ])
      });

      // press quote button popup
      // wait some time for scrolling
      setTimeout(() => {
        this.props.handler.openPopup(
          filter(this.props.posts, ['page', 'QUOTATION'])
        );
      }, 400);
    }

    if (!prevProps.registerSuccess && this.props.registerSuccess) {
      console.warn('quotation page');
      if (localStorage.getItem('register.coupon')) {
        this.props.addCouponRequest({
          user: this.props.user,
          code: localStorage.getItem('register.coupon')
        });
      }

      helpers.clearLocalStorage('register');
    }

    if (
      !prevProps.user &&
      this.props.user &&
      !this.props.basic &&
      this.state.drawerVisible
    ) {
      this.handlePageChange('basic');
    }

    if (!prevProps.basic && this.props.basic && this.state.drawerVisible) {
      this.handleDrawerClose();
      this.gotoNext();
    }

    if (!prevProps.getAutoSaveFinished && this.props.getAutoSaveFinished) {
      this.setState({
        autosaveLoaded: true
      });
      const { recoverFormData } = this.props;
      const signleOrder = recoverFormData;

      if (signleOrder.boxData && !this.state.bypassRecoverFormData) {
        const { boxData } = signleOrder;
        boxData.totalWeight = round(boxData.totalWeight, 1);
        boxData.totalVolumeWeight = round(boxData.totalVolumeWeight, 1);
        boxData.previewWeight = round(boxData.previewWeight, 1);

        this.setState(
          {
            origin: signleOrder.fromCountry,
            destination:
              signleOrder.fromCountry === 'HK' ? signleOrder.toCountry : 'HK',
            boxData
          },
          () => {
            this.parcelForm.current.initBoxData({
              ...boxData,
              boxes: cloneDeep(boxData.boxes)
            });
          }
        );
      }
    }

    if (!prevProps.posts && get(this.props.posts, 'success')) {
      // land quotation page popup
      this.props.handler.openPopup(
        filter(this.props.posts, ['page', 'QUOTATION'])
      );
    }
  }

  componentDidMount() {
    let eventData = {
      event: 'Land Quotation Page',
      ecommerce: undefined
    };

    if (this.props.user !== false) {
      const {
        userType,
        name,
        phone,
        phoneCc,
        email,
        user
      } = this.props.userData;
      eventData = {
        ...eventData,
        userId: user,
        email,
        name,
        userData: {
          userType,
          name,
          phone,
          phoneCc
        }
      };
    }

    window.dataLayer.push(eventData);

    this.props.getAutoSaveRequest();
    this.props.getCountriesRequest();
    this.props.getCategoriesRequest();
    this.props.getAreasRequest();

    const params = queryString.parse(this.props.location.search);

    const newState = {};

    if (
      params.origin &&
      params.origin !== 'HK' &&
      keyBy(this.props.countries, 'alpha-2')[params.origin]
    ) {
      newState.origin = params.origin;
      newState.destination = 'HK';
    } else if (
      params.destination &&
      params.destination !== 'HK' &&
      keyBy(this.props.countries, 'alpha-2')[params.destination]
    ) {
      newState.origin = 'HK';
      newState.destination = params.destination;
    }

    let boxData;

    if (params.length && params.width && params.height && params.quantity) {
      const length = round(params.length);
      const width = round(params.width);
      const height = round(params.height);
      const quantity = round(params.quantity);
      const totalWeight = round(params.totalWeight, 1);
      const totalVolumeWeight = round(
        (length * width * height * quantity) / 5000,
        1
      );

      boxData = {
        totalWeight: totalWeight || totalVolumeWeight,
        totalVolumeWeight: totalVolumeWeight,
        previewWeight: max([totalWeight, totalVolumeWeight]),
        totalBox: quantity,
        boxes: [
          {
            length,
            width,
            height,
            quantity
          }
        ]
      };
      newState.boxData = boxData;
    }

    if (!isEmpty(newState)) newState.bypassRecoverFormData = true;

    this.setState(newState, () => {
      if (boxData) {
        this.parcelForm.current.initBoxData({
          ...boxData,
          boxes: cloneDeep(boxData.boxes)
        });
      }
    });
  }

  parcelForm = React.createRef();

  validateTotalWeight = () => {
    this.parcelForm.current.validateTotalWeight();
  };

  validateCountries = () => {
    const newState = {};
    if (!this.props.origin) newState.originStatus = 'error';
    if (!this.props.destination) newState.destinationStatus = 'error';
  };

  renderSingleOverload = (template, carrier, weight) => {
    return (
      <div
        style={{
          fontSize: '12px',
          padding: '10px',
          margin: '10px',
          backgroundColor: 'rgba(245, 35, 45, .1)',
          borderRadius: '4px'
        }}>
        <span
          style={{
            paddingRight: '10px',
            color: '#ED3535'
          }}>
          <FontAwesomeIcon icon={['fa', 'exclamation-circle']} />
        </span>
        <span
          dangerouslySetInnerHTML={{
            __html: this.props.t(`quotation.${template}`, {
              carrier,
              weight
            })
          }}
        />
      </div>
    );
  };

  renderOverload = () => {
    const { rates, previewWeight, destination } = this.state;
    let node = null;
    const nodeArr = [];
    const haveFedexIp = filter(rates, el => el.service === 'fedex-ip');

    const isTpac = map(
      filter(
        this.props.countries,
        x => x.continent === 'South America' || x.continent === 'North America'
      ),
      'alpha-2'
    ).includes(destination);

    const isEurope = map(
      filter(this.props.countries, x => x.continent === 'Europe'),
      'alpha-2'
    ).includes(destination);

    if (haveFedexIp.length > 0 && previewWeight > 299 && isTpac) {
      node = this.renderSingleOverload('overload_notice', 'FedEx', 500);
      nodeArr.push(node);
    }

    if (
      haveFedexIp.length > 0 &&
      previewWeight > 299 &&
      (isEurope || destination === 'AE')
    ) {
      node = this.renderSingleOverload('overload_notice', 'FedEx', 299);
      nodeArr.push(node);
    }

    return (
      <Fragment>
        {nodeArr.map((el, i) => (
          <Fragment key={i}>{el}</Fragment>
        ))}
      </Fragment>
    );
  };

  getVolumeWeightPopup = () => {
    const baseUrl =
      'https://spaceship-product-images.s3.ap-east-1.amazonaws.com/post_feature_images/volume-weight-explain';

    return [
      {
        id: 0,
        content: (
          <StyledPopup>
            <div className="subtitle">
              {this.props.t('popup.volume_weight_explain.subtitle')}
            </div>
            <div className="title buttonTheme-color">
              {this.props.t('popup.volume_weight_explain.title')}
            </div>
            <div style={{ textAlign: 'center', padding: '20px 0 20px 10px' }}>
              <img
                src={`${baseUrl}-${this.props.t('key')}.png`}
                srcSet={`
                ${baseUrl}-${this.props.t('key')}.png 1x,
                ${baseUrl}-2x-${this.props.t('key')}.png 2x,
                ${baseUrl}-3x-${this.props.t('key')}.png 3x
                `}
              />
            </div>
          </StyledPopup>
        )
      },
      {
        id: 1,
        content: (
          <StyledPopup>
            <div className="subtitle">
              {this.props.t('popup.volume_weight_explain_2.subtitle')}
            </div>
            <div className="title buttonTheme-color">
              {this.props.t('popup.volume_weight_explain_2.title')}
            </div>
            <div style={{ textAlign: 'center', padding: '20px 0 20px 10px' }}>
              <img
                src={`https://spaceship-product-images.s3.ap-east-1.amazonaws.com/post_feature_images/calculation-${this.props.t(
                  'key'
                )}.png`}
                srcSet={`
                https://spaceship-product-images.s3.ap-east-1.amazonaws.com/post_feature_images/calculation-${this.props.t(
                  'key'
                )}.png 1x,
                https://spaceship-product-images.s3.ap-east-1.amazonaws.com/post_feature_images/calculation-${this.props.t(
                  'key'
                )}%402x.png 2x,
                https://spaceship-product-images.s3.ap-east-1.amazonaws.com/post_feature_images/calculation-${this.props.t(
                  'key'
                )}%403x.png 3x
                `}
              />
            </div>
            <div>
              <span
                dangerouslySetInnerHTML={{
                  __html: this.props.t('popup.volume_weight_explain_2.body')
                }}></span>
            </div>
          </StyledPopup>
        )
      }
    ];
  };

  openStaticPopup = popups => {
    this.setState({
      popupKey: !this.state.popupKey,
      popups
    });
  };

  render() {
    return (
      <div
        className="quotation-content"
        style={{
          flex: '1 0 auto',
          display: 'flex',
          flexDirection: 'column',
          margin: '0 auto',
          overflowX: 'hidden',
          width: '100%',
          maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
        }}>
        <div style={{ flex: '1 0 auto' }}>
          <div
            style={{
              padding: '25px 15px 60px'
            }}>
            <Row
              className="buttonTheme-color"
              style={{
                color: '#57D7DD',
                fontSize: '24px',
                fontWeight: 700
              }}>
              <Col span={12}>
                {`${this.props.t('quotation.from_place')} `}
                <img
                  className="image-filter theme"
                  src={ImagePlane}
                  style={{
                    width: '56.2px',
                    paddingBottom: '2px'
                  }}
                  alt=""
                />
              </Col>
              <Col
                span={12}
                style={{
                  textAlign: 'right'
                }}>
                {this.props.t('quotation.to_place')}
              </Col>
            </Row>
            <div
              style={{
                padding: '10px 0'
              }}>
              <Row gutter={14}>
                <Col span={12}>
                  <CountrySelect
                    t={this.props.t}
                    value={this.state.origin}
                    countries={this.props.countries}
                    handleChange={this.handleOriginChange}
                    disable={this.props.countriesLoading}
                    validateStatus={this.state.originStatus || ''}
                    key={this.props.t('key')}
                  />
                </Col>
                <Col span={12}>
                  <CountrySelect
                    t={this.props.t}
                    value={this.state.destination}
                    countries={this.props.countries}
                    handleChange={this.handleDestinationChange}
                    disable={this.props.countriesLoading}
                    validateStatus={this.state.destinationStatus || ''}
                    key={this.props.t('key')}
                  />
                </Col>
              </Row>
            </div>
            <ParcelForm
              t={this.props.t}
              ref={this.parcelForm}
              origin={this.state.origin}
              destination={this.state.destination}
              boxData={this.state.boxData}
              validateTotalWeight={this.validateTotalWeight}
              validateCountries={this.validateCountries}
              updateBoxData={this.handleBoxDataChange}
              openStaticPopup={this.openStaticPopup}
              getVolumeWeightPopup={this.getVolumeWeightPopup}
            />
            <QuotationButton
              t={this.props.t}
              origin={this.state.origin}
              destination={this.state.destination}
              boxData={this.state.boxData}
              validateTotalWeight={this.validateTotalWeight}
              validateCountries={this.validateCountries}
              autosaveLoaded={this.state.autosaveLoaded}
            />
          </div>
        </div>
        <LoginDrawer
          visible={this.state.drawerVisible}
          onClose={this.handleDrawerClose}
          onPageChange={this.handlePageChange}
          email={this.state.drawerEmail}
          page={this.state.drawerPage}
        />
        {this.state.popups && (
          <Popup key={!!this.state.popupKey} popups={this.state.popups} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    rates: state.shipments.rates || [],
    showRates: state.shipments.showRates || false,
    registerSuccess: !!state.auth.registerSuccess,
    user: state.auth.user || false,
    userData: state.auth || false,
    basic: !!state.auth.basic,
    getAutoSaveFinished: !!state.shipments.getAutoSaveFinished,
    recoverFormData: state.shipments.recoverFormData || {},
    countries: state.shipments.countries || countriesData,
    countriesLoading: state.shipments.countries ? false : true,
    posts: state.shipments.posts || false
  };
};

const mapDispatchToProps = {
  getCountriesRequest,
  getCategoriesRequest,
  getAreasRequest,
  getQuotationRequest,
  getAutoSaveRequest,
  addCouponRequest
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Quotation)
);
